import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, duration, InputAdornment, MenuItem, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
// components
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import FormProvider, { RequiredLabel, RHFSelect, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers';
import { priority } from 'src/_mock';
import { dateformation2,getDurationInDays } from 'src/components/date-format-mdy';
import { postRequest } from 'src/services';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import { enqueueSnackbar } from 'notistack';
import { handleErrorMessages } from '../risk-management/risk-register/feching';
import { endpoints } from 'src/utils/axios';
import {extractNumericId} from '../Gantt/utils/utils'

// ----------------------------------------------------------------------

export default function AddEditTask({  item, open, onClose,selectedTask }) {
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState('');
  const { refreshData } = useData();
  // Validation schema
  const NewUserSchema = Yup.object().shape({
    description: Yup.string().required('Task Description is required'),
    start_date:  Yup.string().required('Start Date is required'),
    end_date:  Yup.string().required('End Date is required'),
    priority: Yup.string().required('Priority is required'),
  });

  const defaultValues = useMemo(
    () => ({
      description: item?.text || '',
      start_date:item?.start_date || null,
      end_date:new Date(item?.finish_date) || null,
      priority:item?.priority || ''
    }),
    [item]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });
  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const values = watch();

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

    const onSubmit = handleSubmit(async (data) => {
      setLoading(true);
    const apiData={
      description:data.description,
      planned_start_date:dateformation2(data.start_date),
      planned_finish_date:dateformation2(data.end_date),
      duration:getDurationInDays(data.start_date,data.end_date),
      priority:data.priority,
      ...(selectedTask?.$rendered_parent
        ? {
            taskable_type: 'App\\PlannedCostCode',
            taskable_id: extractNumericId(selectedTask.$rendered_parent),
          }
        : {})
    }
      try {
        const response = await  postRequest(item
          ? `${endpoints.ganttChart.post_task}/${extractNumericId(item.id)}?_method=PUT`
          : endpoints.ganttChart.post_task,
          apiData,
          false
        );
        if (response.metadata && response.metadata.success) {
          reset();
          refreshData();
          onClose();
          enqueueSnackbar({
            variant: 'success',
            message: item ? 'Task Updated successfully' : 'Task Created successfully',
          });
        } else {
          handleErrorMessages(response?.message || 'An error occurred.');
        }
      } catch (err) {
        console.error('Error:', err);
        handleErrorMessages(err.message || 'Submission failed.');
      } finally {
        setLoading(false);
      }
    });
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={() => { onClose(); reset(); }}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3), background: '#F4F6F8', mb: 2 }}>
          New Task
          <Iconify
            icon="ri:close-line"
            style={{ position: 'absolute', right: '30px', cursor: 'pointer' }}
            onClick={() => { onClose(); reset(); }}
          />
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
          <Box
            gap={3}
            display="grid"
            gridTemplateColumns={{
              xs: 'repeat(1, 1fr)',
              lg: 'repeat(1, 1fr)',
            }}
          >
            <RHFTextField  name="description" label='Cost Code Task Description' />
            <Controller
								name="start_date"
								// control={control}
								render={({ field, fieldState: { error } }) => (
									<DatePicker
									minDate={new Date()}
										label="Discount Start Date"
										name="start_date"
										value={field.value}
										onChange={(newValue) => {
											
											field.onChange(newValue);
											// const endDate =getValues('end_date');
											// if (newValue && endDate && newValue > endDate) {
											//   setError('start_date', {
											// 	message: 'Start Date cannot be later than End Date',
											//   });
											// } else {
											//   clearErrors('start_date');
											//   clearErrors('end_date');
											// }
										}}
										slotProps={{
											textField: {
												fullWidth: true,
												error: !!error,
												helperText: error?.message,
											},
										}}
									/>
								)}
							/>
                <Controller
                  name="end_date"
                  // control={control}
                  render={({ field, fieldState: { error } }) => (
                    <DatePicker
                      minDate={new Date()}
                      label="Discount End Date"
                      name="end_date"
                      value={field.value}
                      onChange={(newValue) => {
                        field.onChange(newValue);
                      //   const startDate = getValues('start_date');
                      // console.log(startDate)
                      // console.log(newValue)

                      //   if (newValue && startDate && newValue < startDate) {
                      //     setError('end_date', {
                      //     message: 'End Date cannot be earlier than Start Date',
                      //     });
                      //   } else {
                      //     clearErrors('end_date');
                      //     clearErrors('start_date');
                      //   }
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!error,
                          helperText: error?.message,
                        },
                      }}
                    />
                  )}
                />
                 <RHFSelect
                name={`priority`}
                label="Priority"
              >
                {priority?.map((service) => (
                  <MenuItem key={service.value} value={service.value}>
                    {service.label}
                  </MenuItem>
                ))}
              </RHFSelect>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => { onClose(); reset(); }} className="danager">
            Cancel
          </Button>
          <LoadingButton loading={loading} variant="contained" onClick={onSubmit}>
             Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}

AddEditTask.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  item: PropTypes.object,
};
